import { makeAutoObservable, runInAction } from "mobx";
import { history } from "../..";
import agent from "../api/agent";
import { changePasswordFormValues, resetPasswordFormValues, User, userFormValues, userRegistrationValues,  WeeklyForecastValues } from "../models/user";
import { store } from "./store";
import DeviceUUID from "device-uuid";

export default class UserStore{
    resetPassword = async (email:string) => {
        const creds = {email: email, password: "", deviceID:  new DeviceUUID.DeviceUUID().get() }
        await agent.Account.resetPassword(creds);
    }

    user: User | null = null;
    refreshTokenTimeOut: any;

    constructor(){
        makeAutoObservable(this);
    }

    get isLogged(){
        return !!this.user;
    }

    get isAdmin(){
        if (this.isLogged){
            if(this.user?.username === "Charles" || this.user?.username === "SteveXie"){
                return true;
            }
        }
        return false;
    }

    changePassword = async(values: changePasswordFormValues)=>{
        const user = await agent.Account.changePassword(values);

        store.commonStore.setToken(user.token);
        this.startRefreshTokenTimer(user);

        runInAction(()=> this.user = user);

        history.push("/");

        store.modalStore.closeModal();

    }

    resetActualPassword = async(values: resetPasswordFormValues)=>{
        await agent.Account.resetActualPassword(values);


        history.push("/");

        store.modalStore.closeModal();

    }

    login = async (creds: userFormValues) =>{
        try{

            creds.deviceID = new DeviceUUID.DeviceUUID().get();
            
            const user = await agent.Account.login(creds);

            store.commonStore.setToken(user.token);
            this.startRefreshTokenTimer(user);

            runInAction(()=> this.user = user);


            store.modalStore.closeModal();
            history.push("/overview");

        }catch(error){
            throw error;
        }
    }

    getPhotoURL = () => {
        const photoPath = this.user == null || this.user.image == null ? "/assets/user.png": agent.Photo.getURL(this.user?.image!);

        return photoPath;
    }

    systemLogout =  async() => {
        this.logout();
        await agent.Account.logout().catch((err) => {
            console.log("Logout Error" , err);
        });

    }

    logout =  () => {

        store.commonStore.setToken(null);


        window.localStorage.removeItem("totogm_jwt_new");
        this.user = null;
        history.push("/");
    }

    getUser = async() =>{
        try{
            const user = await agent.Account.current();
            store.commonStore.setToken(user.token);
            this.startRefreshTokenTimer(user);

            runInAction(()=>{
                this.user = user;
            });
        }catch(error){
            console.log(error);
        }
    }

    changeDisplayName = async (userValue: userFormValues, file: any) =>{
        try{


            let formData = new FormData();
            formData.append('file', file);
            formData.append('password', userValue.password);
            formData.append('email', userValue.email);
            formData.append('displayName', userValue.displayName!);

            
            const returnUser = await agent.Account.changeDisplayName(formData);


            store.modalStore.closeModal();

            store.commonStore.setToken(returnUser.token);
            this.startRefreshTokenTimer(returnUser);

            runInAction(()=>{
                this.user = returnUser;

                history.push("/profile");
            });
            
        }catch(error){
            throw error;
        }
    }

    register = async (creds: userRegistrationValues) =>{
        try{
            creds.deviceID = new DeviceUUID.DeviceUUID().get();
            await agent.Account.register(creds);

            store.modalStore.closeModal();
        }catch(error){
            throw error;
        }
    }

    renewSubscription = async (creds: userRegistrationValues) =>{
        try{
            creds.deviceID = new DeviceUUID.DeviceUUID().get();
            await agent.Account.renewSubscription(creds);

            store.modalStore.closeModal();
        }catch(error){
            throw error;
        }
    }

    changeDevice = async (creds: userRegistrationValues) =>{
        try{
            creds.deviceID = new DeviceUUID.DeviceUUID().get();
            await agent.Account.changeDevice(creds);

            store.modalStore.closeModal();
        }catch(error){
            throw error;
        }
    }

    refreshToken = async () => {
        try{
            
            this.stopRefreshTokenTimer();
            const user = await agent.Account.refreshToken();

            runInAction(()=> this.user = user);
            store.commonStore.setToken(user.token);

            this.startRefreshTokenTimer(user);

        }catch(error){
            console.log(error);
        }
    }

    private startRefreshTokenTimer(user: User){
        const jwtToken = JSON.parse(atob(user.token.split('.')[1]));


        const expires = new Date(jwtToken.exp * 1000);
        
        const timeout = expires.getTime() - new Date().getTime() - (30 * 1000);
        
        this.refreshTokenTimeOut = setTimeout(this.refreshToken, timeout);
    }

    private stopRefreshTokenTimer(){
        clearTimeout(this.refreshTokenTimeOut);
    }
}